import React, { useState } from "react";
import "./SavePromptModal.css"; // For styling
import { Box, Button, Modal } from "@mui/material";
import IoClose from "../../../../../assets/images/IoClose.svg";
import { getRouteId, SNACKBAR_TYPES } from "../../../../../constants/constant";
import { useLocation } from "react-router-dom";
import { clarityNav } from "../../../../../services/api/clarityNav/apiService";
import { useDispatch, useSelector } from "react-redux";
import { closePromptModal, closeSavePromptModal, setRefreshPrompts } from "../../../../../features/Modal/ModalSlice";
import { openSnackbar } from "../../../../../features/snackbar/snackbarslice";

function SavePromptModal({  promptId, themeData, themename }) {
  const dispatch = useDispatch();
  const [promptName, setPromptName] = useState("");
  const location = useLocation();
  const project_id = getRouteId(location.pathname);
  const [SaveprojectPrompts] = clarityNav.useSaveProjectPromptsMutation();
  const handleInputChange = (event) => {
    setPromptName(event.target.value);
  };
  const open = useSelector((state) => state.ModalSlice.isSavePromptModalOpen);
  const newpromptPayload = {
    prompt_name: promptName,
    prompt_id: promptId,
    theme_name: themename,
    theme_data: themeData,
    is_master: false,
  };
  const handlesavePrompt = async () => {
    try {
      const saveNewPrompt = await SaveprojectPrompts({
        data: newpromptPayload,
        project_id: project_id,
      }).unwrap();
      
      // Clear the input
      setPromptName("");
      
      // Trigger prompt refresh
      dispatch(setRefreshPrompts(true));
      
      // Close modals
      dispatch(closeSavePromptModal());
      dispatch(closePromptModal());
    } catch (error) {
      console.log(error);
      // dispatch(openSnackbar({ message: error?.message?.[0],type: SNACKBAR_TYPES.ERROR,}));
      // Extract error message from the response
      const errorMessage = error?.data?.message || 'Something went wrong';
        
      // Show error in snackbar
      dispatch(openSnackbar({ 
          message: errorMessage,
          type: SNACKBAR_TYPES.ERROR 
      }));
    }
  };
  const handleModalClose = () => {
    setPromptName(""); // Clear input when modal is closed
    dispatch(closeSavePromptModal());
  };

  return (
    <>
      <Modal
        open={open}
        onClose={handleModalClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className="savePromptModal" onClick={(e) => e.stopPropagation()}>
          <Button
            className="closeModalBtn sizeLarge"
            onClick={handleModalClose}
          >
            <img width="24px" height="24px" src={IoClose} alt="close" />
          </Button>
          <div className="file_header">
            <div className="attach"> Save As</div>
            <div className="header_right d-flex align-items-baseline gap-3"></div>
          </div>
          <div className="DropBox w-100 d-flex flex-column align-items-center justify-content-center promptName-Input-box">
            <div className="promptcontentBgBox">
              <h4 className="prompt-save-heading">Prompt Name</h4>
              <input
                type="text"
                value={promptName}
                onChange={handleInputChange}
                className="prompt-name-input-field"
              />
            </div>
          </div>
          <div className="w-100 d-flex justify-content-end px-4 pt-2 pb-4 gap-[8px]">
            <Button onClick={handleModalClose} className="close_btn w-[110px]">
              Cancel
            </Button>
            <Button
              onClick={handlesavePrompt}
              className="validate_btn_enabled w-[110px]"
              // disabled={currentusername !== currentProjectOwner}'
            >
              Save
            </Button>
          </div>
        </Box>
      </Modal>
    </>
  );
}

export default SavePromptModal;
